import gql from "graphql-tag";

export const graphQL_shema = ()=> {

    const Get_Stations_Themes_Categories = gql`
        query getInfoForm($empty: String!) {
            getInfoForm(empty: $empty) {
                categories{
                    id
                    title
                }
                themes{
                    title
                    id
                }
                stations{
                    id
                    name
                    IsAuto
                }
            }
        }
    `;

    const getEvent_byID = gql`
      query getEventByID($id: Int!,$lang:String!) {
        getEventByID(id: $id,lang:$lang) {
          eventOrganizer {
            id
            richMediaPresentation
            urlTitle
            url
            vodRecord
            organizerName
            organizerEmail
            smsCount
            accessType
            comment
            timeStart
            timeStop
            isAuto
            ProcessorGUID
            VideoPortIndex
            AudioPortIndex
            ProtocolType
            StartRecord
            isDvr
            isYoutube
            stations {
              id
              name
              IsAuto
            }
            categorys {
              id
              title
            }
          }
          videoMedia {
            logoName
            video {
              id
              copyright
              title
              keyWords
              logo
              startDate
              endDate
              description
              downloadable
              isVisibleOnInternet
              countries{
               country_name
               id
              }
              filesVideo {
              title
              fileName
              }
              isSecuredOnInternet
              passwordInternet

              themes {
                id
                title
              }
            }
            langs
            youtubeLinks {
              links {
                lang
                link
              }
            }
          }
        }
      }
    `;

    const CREATE_EVENT = gql`

        mutation($empParametersCanalForm:EventOrganizerForm!) {
            createEventOrganizer(empParametersCanalForm:$empParametersCanalForm){
                code
                message
            }
        }
    `;
    const UPDATE_EVENT = gql`

        mutation($id:Int!$empParametersCanalForm:EventOrganizerForm!) {
            updateEventOrganizer(id:$id,empParametersCanalForm:$empParametersCanalForm){
                code
                message
            }
        }
    `;
    const DELETE_EVENT = gql`
        mutation($idList:[Int!]!) {
            deleteEventOrganizers(idList:$idList){
                deleteditems
                undeleteditems
                code
            }
        }`;
    const START_EVENT = gql`
        mutation($id: Int!, $status: Int!) {
            updateEventOrganizerStatus(id: $id, status: $status){
                code
                message
            }
        }
    `;
    const START_RECORD_ON_DNS = gql`
        mutation($isDvr: Boolean!, $streamName: String!, $body: String!) {
            startRecordOnDns(isDvr: $isDvr, streamName: $streamName, body: $body){
                code
                message
            }
        }
    `;
    const STOP_RECORD_ON_DNS = gql`
        mutation($streamName: String!, $isDvr: Boolean, $isAuto: Boolean) {
            stopRecordOnDns(streamName: $streamName, isDvr: $isDvr, isAuto: $isAuto){
                code
                message
            }
        }
    `;
    const uploadToS3 = gql`
        mutation ($file:Upload! $subFolder: String!){
            uploadToS3(file:$file subFolder:$subFolder){
                code
                message
            }
        }
    `
    const UPLOAD_FILE = gql`
        mutation ($file:Upload!)
        {uploadLogo(logo:$file)}

    `;
    const Get_Video_Links = gql`
      query ($idVideo: Int!, $lang: String!) {
        getVideoLinks(idVideo: $idVideo, lang: $lang) {
          code
          youtubeLinks {
            links {
              lang
              link
            }
          }
          srtLink
          srtLink2
          rtmpLink
          rtmpLink2
          videoUrl
          auto {
            permaLink {
              permaLink {
                intranet
                internet
              }
              permaLinkCdn {
                intranet
                internet
              }
            }
            embed {
              embedLink {
                intranet
                internet
              }
              embedLinkCdn {
                intranet
                internet
              }
            }
          }
          live {
            permaLink {
              permaLink {
                intranet
                internet
              }
              permaLinkCdn {
                intranet
                internet
              }
            }
            embed {
              embedLink {
                intranet
                internet
              }
              embedLinkCdn {
                intranet
                internet
              }
            }
          }

          video {
            permaLink {
              permaLink {
                intranet
                internet
              }
              permaLinkCdn {
                intranet
                internet
              }
            }
            embed {
              embedLink {
                intranet
                internet
              }
              embedLinkCdn {
                intranet
                internet
              }
            }
          }
        }
      }
    `;
    const DELETE_LANG = gql `
    mutation( $idVideo:Int!,$lang:String!) {
   deleteLang(idVideo:$idVideo,lang:$lang ) {
    code
    message
    }
}
    `;

    const Get_Calendar_Data = gql`
        query($input: NewEventsPagination,$dates: [String!]!) {
            getCalendar(input: $input,dates:$dates) {
                id
                cType
                content
                startRecord
                thumbnailUrl
                status
                date{
                    date
                    isAMomentObject
                }
            }
        }
    `;

    const Get_langues = gql`
        query {
            getLanguages {
                id
                label
                lang
            }
        }
    `;

    const Get_Action = gql`
    query($idUser: Int!){
  getActions(idUser:$idUser){
      superAdmin
      code
      data{
      id
      name
      }
    }
    }
    `;

    const Get_Export_Url = gql`
    query($idVideo: Int!, $lang: String! ){
  getExportUrl(idVideo:$idVideo, lang:$lang){
    code
    auto{
    permaLink{
      permaLink{
          intranet
          internet
      }
      permaLinkCdn{
          intranet
          internet
      }        
    }
    embed{
      embedLink{
          intranet
          internet
      }
      embedLinkCdn{
          intranet
          internet
      }        
    }      
    }
    live{
        permaLink{
          permaLink{
              intranet
              internet
          }
          permaLinkCdn{
              intranet
              internet
          }        
        }
        embed{
          embedLink{
              intranet
              internet
          }
          embedLinkCdn{
              intranet
              internet
          }        
        }      
        }
        video{
            permaLink{
              permaLink{
                  intranet
                  internet
              }
              permaLinkCdn{
                  intranet
                  internet
              }        
            }
            embed{
              embedLink{
                  intranet
                  internet
              }
              embedLinkCdn{
                  intranet
                  internet
              }        
            }      
            }
  }
  }
    `;


    const Get_Export_Excel = gql`
    query($start_date: String!, $end_date: String! ){
    getExcelFile(start_date:$start_date, end_date:$end_date){
    code
    link
  }
  }
    `;


    const GET_EVENTS = gql`
        query($input: NewEventsPagination) {
            getEvents(input: $input) {
                data{
                    id
                    rich_media_presentation
                    timeStart
                    timeStop
                    StartRecord
                    StartRecordTime
                    isDvr
                    isYoutube
                    isStandby
                    ConferenceKey
                    date
                    isAuto
                    ProcessorGUID
                    VideoPortIndex
                    AudioPortIndex
                    ProtocolType
                    vodRecord
                    video{
                        id
                        title
                        date
                        is_visible_on_internet
                        is_secured_on_internet
                        
                        start_date
                        end_date
                        duration
                        date
                        logo
                        thumbnail_url

                    }
                    medias{
                        id
                        lang
                    }
                    station{
                        id
                        ip
                        name
                        domain
                        intranetStreamFr
                        intranetStreamEn
                        intranetStreamEs
                        intranetStreamOr
                        description
                      }

                }
                records_total
                records_filtered
                code
            }
        }
    `;

    const Stop_Event = gql`
        mutation($idVideo: Int!, $endDate: String !) {
            stopLiveEvent(idVideo:$idVideo, endDate:$endDate){
                code
                message
            }}
    `;

    const CLIENT_NAME = gql`

        mutation ($clientName: String !){
         automatedEventUpdates(clientName:$clientName){
          code
          message
        }
      }
    `;
    const trashEvent = gql`

    mutation ($idList:[Int!]!){
        trashEventOrganizers(idList:$idList){
        affecteditems
        unaffecteditems
      code
    }
  }
`;
const getTrashedEvents = gql`
        query($input: NewEventsPagination) {
            getEvents(input: $input) {
                data{
                    id
                    rich_media_presentation
                    timeStart
                    timeStop
                    StartRecord
                    isDvr
                    isStandby
                    date
                    video{
                        id
                        title
                        date
                        is_visible_on_internet
                        
                        is_secured_on_internet
                       
                        start_date
                        end_date
                        duration
                        date
                        logo
                        thumbnail_url

                    }
                    medias{
                        id
                        lang
                    }
                    station{
                        id
                        ip
                        name
                        domain
                        intranetStreamFr
                        intranetStreamEn
                        intranetStreamEs
                        intranetStreamOr
                        description
                      }

                }
                records_total
                records_filtered
                code,
                __typename
            }
        }
    `;
    const restoreEvent = gql`
    mutation ($idList:[Int!]!){
     restoreEventOrganizers(idList:$idList ){
      code,
      affecteditems,
      unaffecteditems
    }
  }
`;
const Set_Event_Standby_Mode = gql`
mutation($eventID: Int!, $standbyMode: Boolean!) {
  setEventStandbyMode(eventID: $eventID, standbyMode: $standbyMode) {
    code
    message
  }
}
`;
    return({
        Get_Stations_Themes_Categories,
        CREATE_EVENT,
        getEvent_byID,
        UPDATE_EVENT,
        DELETE_EVENT,
        START_EVENT,
        START_RECORD_ON_DNS,
        STOP_RECORD_ON_DNS,
        UPLOAD_FILE,
        Get_Video_Links,
        DELETE_LANG,
        Get_Calendar_Data,
        Get_langues,
        Get_Action ,
        GET_EVENTS,
        Stop_Event,
        CLIENT_NAME,
        Get_Export_Url,
        Get_Export_Excel,
        uploadToS3,
        trashEvent,
        getTrashedEvents,
        restoreEvent,
        Set_Event_Standby_Mode
    })
}